import { GetStaticProps } from 'next';
// import { useEffect } from 'react';
import { QueryClient } from 'react-query';
import { dehydrate } from 'react-query/hydration';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { API_ENDPOINTS } from '@framework/utils/api-endpoints';
import { fetchMainSliders } from '@framework/content/get-main-sliders';
import { fetchCategories } from '@framework/category/get-all-categories';
import { fetchMainProducts } from '@framework/product/get-all-main-products';
import Layout from '@components/layout/layout';
import Container from '@components/ui-old/container';
import HeroBlock from '@containers/hero-block';
import CategoryBlock from '@containers/category-block';
import MainProductFeed from '@components/product/feeds/main-product-feed';
import MainIconBlock from '@containers/main-icons';
import DownloadApps from '@components/common/download-apps';
// import Support from '@components/common/support';

import Divider from '@components/ui-old/divider';
import React from 'react';
import HomepageNews from '@components/news/homepage-news';
import CommonMessageHome from '@components/commom-message/common-message-home';
import PwaToast from '@components/other/pwa-alert';
import { ProductMarquee } from '@components/ui/product-marquee';
import EshopHomeButton from '@components/other/e-shop-home';

// import { useUI } from '@contexts/ui.context';

// import BannerCard from '@components/common/banner-card';
// import CollectionBlock from '@containers/collection-block';
// import BrandBlock from '@containers/brand-block';
// import FeatureBlock from '@containers/feature-block';
// import BestSellerProductFeed from '@components/product/feeds/best-seller-product-feed';
// import NewArrivalsProductFeed from '@components/product/feeds/new-arrivals-product-feed';
// import FlashSaleBlock from '@components/product/feeds/flash-sale-product-feed';
// import BannerCarouselBlock from '@containers/banner-carousel-block';
// import { homeOneBanner as banner } from '@framework/static/banner';
// import { fetchFlashSaleProducts } from '@framework/product/get-all-flash-sale-products';
// import { fetchBestSellerProducts } from '@framework/product/get-all-best-seller-products';
// import { fetchNewArrivalProducts } from '@framework/product/get-all-new-arrival-products';
// import { fetchBrands } from '@framework/brand/get-all-brands';
// import { collectionData as collection } from '@framework/static/collection';
// import { ROUTES } from '@utils/routes';
// import { promotionBannerTwo as promotionBanners } from '@framework/static/banner';

export default function Home() {
  // const { openModal, setModalView } = useUI();
  // useEffect(() => {
  //   setModalView('NEWSLETTER_VIEW');
  //   setTimeout(() => {
  //     openModal();
  //   }, 2000);
  // }, []);
  return <>
      <PwaToast data-sentry-element="PwaToast" data-sentry-source-file="index.tsx" />
      <HeroBlock data-sentry-element="HeroBlock" data-sentry-source-file="index.tsx" />
      <CommonMessageHome data-sentry-element="CommonMessageHome" data-sentry-source-file="index.tsx" />
      <Container data-sentry-element="Container" data-sentry-source-file="index.tsx">
        {/* <FlashSaleBlock /> */}
        {/* <BannerCarouselBlock bannerData={promotionBanners} /> */}
        <CategoryBlock sectionHeading='text-shop-by-category' data-sentry-element="CategoryBlock" data-sentry-source-file="index.tsx" />
        <Divider data-sentry-element="Divider" data-sentry-source-file="index.tsx" />
        <EshopHomeButton data-sentry-element="EshopHomeButton" data-sentry-source-file="index.tsx" />
        <MainProductFeed data-sentry-element="MainProductFeed" data-sentry-source-file="index.tsx" />
        <Divider data-sentry-element="Divider" data-sentry-source-file="index.tsx" />
        <HomepageNews data-sentry-element="HomepageNews" data-sentry-source-file="index.tsx" />
        <MainIconBlock data-sentry-element="MainIconBlock" data-sentry-source-file="index.tsx" />
        {/* <BestSellerProductFeed />
         <BannerCard
          key={`banner--key${banner.id}`}
          banner={banner}
          href={`${ROUTES.COLLECTIONS}/${banner.slug}`}
          className='mb-12 lg:mb-14 xl:mb-16 pb-0.5 lg:pb-1 xl:pb-0'
          classNameInner='h-28 sm:h-auto'
         />
         <NewArrivalsProductFeed />
         <Divider />
         <BrandBlock sectionHeading='text-top-brands' />
         <CollectionBlock data={collection} />
         <FeatureBlock /> */}
        <ProductMarquee data-sentry-element="ProductMarquee" data-sentry-source-file="index.tsx" />
        <DownloadApps className='bg-aloeGold' data-sentry-element="DownloadApps" data-sentry-source-file="index.tsx" />
        {/* <Support /> */}
      </Container>
    </>;
}
Home.Layout = Layout;
export const getStaticProps: GetStaticProps = async ({
  locale
}) => {
  const queryClient = new QueryClient();
  await queryClient.prefetchQuery([API_ENDPOINTS.MAIN_SLIDERS, {
    limit: 5
  }], fetchMainSliders);
  await queryClient.prefetchQuery([API_ENDPOINTS.CATEGORIES, {
    limit: 15
  }], fetchCategories);
  await queryClient.prefetchQuery([API_ENDPOINTS.MAIN_PRODUCTS, {
    limit: 12
  }], fetchMainProducts);
  return {
    props: {
      dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
      ...(await serverSideTranslations(locale!, ['common', 'forms', 'menu', 'footer', 'swal']))
    },
    revalidate: 60
  };
};